import { render, staticRenderFns } from "./AccountTypePage.vue?vue&type=template&id=5a649e4b&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a649e4b')) {
      api.createRecord('5a649e4b', component.options)
    } else {
      api.reload('5a649e4b', component.options)
    }
    module.hot.accept("./AccountTypePage.vue?vue&type=template&id=5a649e4b&", function () {
      api.rerender('5a649e4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/accountType/AccountTypePage.vue"
export default component.exports